import React from 'react';
import styled from 'styled-components';

const StyledDateDisplay = styled.div`
  text-align: right;
`;

const JobsDone = ({ cellData: carrier }) => {
  const { number_of_journeys: number } = carrier;

  return <StyledDateDisplay>{number ? number : ''}</StyledDateDisplay>;
};

export default JobsDone;
